export default "__VITE_ASSET__wtCiQP$r__"